import React, {useState, useEffect, useRef} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import Config from "../../core/config";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import {useNavigate} from "react-router-dom";
import {findPaymentTermsByQueryString} from "../../utils/requestUtils";
import {UserPermission} from "../../utils/utils";
import Loading from "../../core/Loading";
import {usePermission} from "../../core/PermissionContext";
import NewButton from '../common/NewButton';
import TableRowActions from '../common/TableRowActions';
import ListPageLayout from '../common/ListPageLayout';

const apiUrl = Config.apiUrl;
const PaymentTermList = () => {
    const { hasUserPermission, loadingPermissions } = usePermission();
    let [paymentTerms, setPaymentTerms] = useState([]);
    const [queryString, setQueryString] = useState('');
    const inputQueryString = useRef(null);
    const [loading, setLoading] = useRecoilState(loadingAtom);
    const navigate = useNavigate();

    async function makeQuery(query) {
        try {
            setLoading(true);
            const response = await findPaymentTermsByQueryString(query);
            setPaymentTerms(response);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (inputQueryString.current) {
            inputQueryString.current.focus();
        }
        makeQuery('');
    }, []); // Empty dependency array ensures that useEffect runs only once, similar to componentDidMount

    async function deletePaymentTerm(id) {
        try {
            const url = apiUrl + '/api/payment_terms/' + id;
            setLoading(true);
            await makeRequest(url, 'DELETE');
            await makeQuery(queryString);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    const handleInputChange = (e) => {
        const string = e.target.value;
        if (string.length >= 3 || string.length === 0) {
            makeQuery(string);
        }
        setQueryString(string);
    };

    if (loadingPermissions) {
        return <Loading></Loading>;
    }
    if (hasUserPermission(UserPermission.LIST_PAYMENT_TERM) === false) {
        navigate('/unauthorizedaccess');
    }

    return (
        <ListPageLayout
            tableWidth={580}
            header={
                <div style={{display: "flex", alignItems: "center", gap: '10px'}}>
                    <div className="header-label">Consulta de Condições de Pagamento</div>
                    {hasUserPermission(UserPermission.CREATE_PAYMENT_TERM) &&
                        <NewButton className={"new-button"} onClick={() => navigate('/app/paymentterm')}/>
                    }
                </div>
            }
            filters={
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                    <input ref={inputQueryString} type="text" value={queryString} onChange={handleInputChange}/>
                </div>
            }
        >
            <table>

                <tr>
                    <th>
                        Código
                    </th>
                    <th>
                        Nome
                    </th>
                    <th/>
                </tr>
                <tbody style={{overflowY: 'auto'}}>

                {paymentTerms.map((paymentTerm, index) => (


                    <tr style={{backgroundColor: paymentTerm.color}}>
                        <td>
                            <div key={index}>{paymentTerm.code}</div>
                        </td>
                        <td>
                            <div key={index}>{paymentTerm.name}</div>
                        </td>
                        <td>
                            <TableRowActions
                                actions={[
                                    {
                                        key: 'edit',
                                        label: 'Editar',
                                        type: 'edit',
                                        visible: hasUserPermission(UserPermission.EDIT_PAYMENT_TERM),
                                        onClick: () => navigate('/app/paymentterm?id=' + paymentTerm.id),
                                    },
                                    {
                                        key: 'delete',
                                        label: 'Excluir',
                                        type: 'delete',
                                        visible: hasUserPermission(UserPermission.REMOVE_PAYMENT_TERM),
                                        onClick: async () => {
                                            if (window.confirm('Deseja realmente excluir?')) {
                                                await deletePaymentTerm(paymentTerm.id);
                                            }
                                        },
                                    },
                                ]}
                            />
                        </td>

                    </tr>
                ))}
                </tbody>
                {paymentTerms.length === 0 && (<tfoot>{loading ? 'Carregando...' : `Nenhum item encontrado.`}</tfoot>)}
            </table>
        </ListPageLayout>
    );
};

export default PaymentTermList;
